import React, { useEffect, useState } from 'react'

import { ReactTyped } from 'react-typed'

import { ManagementLineThrough } from '../common/Icons'
import PrimaryHeading from '../custom-ui/PrimaryHeading'

const CustomerIntelligence = () => {
  const [isThirdSectionInView, setIsThirdSectionInView] = useState(false)
  const [isAnimationVisible, setIsAnimationVisible] = useState(false)
  const [textVisible, setTextVisible] = useState(false)
  const [textColor, setTextColor] = useState(false)

  useEffect(() => {
    const handleScroll = () => {
      const thirdSection = document.getElementById('customer-intelligence')
      if (thirdSection && isThirdSectionInView === false) {
        const rect = thirdSection.getBoundingClientRect()
        setIsThirdSectionInView(rect.top <= window.innerHeight)
      }
    }

    handleScroll() // Check initial scroll position

    const timeoutId =
      isThirdSectionInView &&
      setTimeout(() => {
        setIsAnimationVisible(true)
      }, 3500)
    // Set a timeout to add the class after 5 seconds (5000 milliseconds) for the second div
    const timeoutId2 =
      isThirdSectionInView &&
      setTimeout(() => {
        setTextVisible(true)
      }, 4500)
    // Set a timeout to add the class after 5 seconds (5000 milliseconds) for the second div
    const timeoutId3 =
      isThirdSectionInView &&
      setTimeout(() => {
        setTextColor(true)
      }, 4000)
    window.addEventListener('scroll', handleScroll)

    // Clear timeout and remove event listener on cleanup
    return () => {
      clearTimeout(timeoutId)
      clearTimeout(timeoutId2)
      clearTimeout(timeoutId3)
      window.removeEventListener('scroll', handleScroll)
    }
  }, [isThirdSectionInView])
  return (
    <div
      className="container mt-12 sm:mb-6 sm:mt-24 md:pt-12"
      id="customer-intelligence"
    >
      <PrimaryHeading class="grid min-h-[clamp(150px,35.8931552588vw,220px)] !text-[clamp(38px,9.6888vw,54px)] !font-semibold leading-[94.444%] sm:min-h-[220px] md:min-h-[155px] xl:min-h-0">
        <span className="relative flex flex-col flex-wrap items-center justify-between xl:flex-row xl:justify-center">
          Customer&nbsp;
          <span className="-top-full flex font-caveat !text-[clamp(48px,9.6888vw,60px)] text-blue xl:absolute">
            {/* Intelligence */}
            {textVisible && (
              <ReactTyped
                showCursor={false}
                strings={['Intelligence']}
                typeSpeed={80}
              />
            )}
          </span>
          <div
            className={`relative flex flex-col px-2 duration-300 md:flex-row ${
              textColor ? 'text-gray' : 'text-blue'
            }`}
          >
            <span className="relative pe-2 md:static">
              <span
                className={`absolute left-0 top-1/2 -translate-y-1/2 duration-300 md:left-2 ${
                  isAnimationVisible ? 'w-full' : 'w-0'
                }`}
              >
                <ManagementLineThrough />
              </span>
              {/* Relationship&nbsp; */}
              {isThirdSectionInView && (
                <ReactTyped
                  showCursor={false}
                  strings={['Relationship']}
                  typeSpeed={80}
                  startDelay={800}
                />
              )}
            </span>

            <span className="relative md:static">
              {/* Management */}
              {isThirdSectionInView && (
                <ReactTyped
                  showCursor={false}
                  strings={['Management']}
                  typeSpeed={80}
                  startDelay={2800}
                />
              )}
              <span
                className={`absolute left-0 top-1/2 -translate-y-1/2 duration-300 md:hidden ${
                  isAnimationVisible ? 'w-full' : 'w-0'
                }`}
              >
                <ManagementLineThrough />
              </span>
            </span>
          </div>
        </span>
      </PrimaryHeading>
      <p className="mt-3 text-center text-2xl font-normal text-night-black">
        Meeting Assistant, CRM, and Knowledge Base combined into a{' '}
        <span className="font-semibold">single unified solution</span>.
      </p>
    </div>
  )
}

export default CustomerIntelligence
